import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const AnalyticsContext = createContext(null);

type Props = {
  children: ReactElement;
};

const AnalyticsProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["analytics"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`overview?keyword=monthly-screening-analytics`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
      error,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <AnalyticsContext.Provider value={contextValue}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export default AnalyticsProvider;
